@if (resultsContent?.resultsPrizes?.length > 0) {
    <div class="results-prizes">
        @if (resultsContent.resultsPrizes.length > 1) {
            @for (prize of resultsContent.resultsPrizes; track prize) {
                <tp-results-prize [resultsPrize]="prize" [showCheckButton]="showCheckButton" class="results-prizes-block"></tp-results-prize>
            }
        }
        @if (resultsContent.resultsPrizes.length === 1) {
            <single-results-prize
                [showCheckButton]="showCheckButton"
                [resultsContent]="resultsContent"
                [showResultsInfo]="showResultsInfo"></single-results-prize>
        }
    </div>
}
